import { useChat, Message } from '@ai-sdk/react'
import { createIdGenerator } from 'ai'

import { useCustomFetch } from '../../hooks/useCustomFetch'
import { useChatStore } from '../askAnything/chatStore'

type UseCustomChatOptions = {
  id: string
  api?: string
  generateId?: () => string
  initialMessages?: Message[]
}

export function useCustomChat({
  id,
  api = '/chat/ai',
  generateId = createIdGenerator({
    prefix: 'msgc',
    size: 16,
  }),
  initialMessages,
}: UseCustomChatOptions) {
  const customFetch = useCustomFetch()

  const { selectedProduct, timeWindow } = useChatStore()

  return useChat({
    id,
    api,
    fetch: (url: string, options: RequestInit) => {
      return customFetch(url, 'POST', options.body, options, false)
    },
    generateId,
    sendExtraMessageFields: true,
    initialMessages,
    experimental_throttle: 100,
    experimental_prepareRequestBody({ messages, id }) {
      return {
        message: messages[messages.length - 1],
        id,
        workspaceId: selectedProduct?.workspace_id,
        productId: selectedProduct?.id,
        timeWindow,
      }
    },
  })
}
